import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState, IAddVoucherHolderResponse } from "../";
import { IAdpVoucherHolderResponse, IBaseResponse, IListItem, IVoucherHolderForList } from '@nkr/models/index';

export interface IDonorProfileVoucherListResponse {
    data: {
        success: boolean,
        message: string,
        results: IVoucherHolderForList[]
    }
}

// export interface IVoucherLookupDataResponse {
//     data: {
//         success: boolean,
//         message: string,
//         results: {
//             aboTypeList: IListItem[],
//             ckdStatusList: IListItem[],
//             voucherHolderStatusList: IListItem[],
//             voucherTypeList: IListItem[],
//             genderList: IListItem[],
//         }
//     }
// }

// export interface IVoucherHolderRequest {
//     abo: number,
//     ckdStatus: number,
//     status: number,
//     type: number,
//     gender: number,
//     firstName: string,
//     lastName: string,
//     country: number,
//     addressLine1: string,
//     addressLine2: string,
//     city: string,
//     stateProvince: string,
//     postalCode: string,
//     phoneNumberPrimary: string,
//     phoneNumberSecondary: string,
//     emailPrimary: string,
//     emailSecondary: string,
//     birthDate: string,
//     isAdmin: boolean
// }

export const ActionCreators = {
    getVouchers: (centerId: number, donorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileVoucherListResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/vouchers`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    // getVoucherHolder: (centerId: number, donorId: number, id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IAdpVoucherHolderResponse> => {
    //     let options = {
    //         url: `${__API__}/center/${centerId}/donor/${donorId}/voucher/${id}`
    //     };

    //     return await dispatch(AuthActionCreators.apiGet(options));
    // },

    // addVoucherHolder: (centerId: number, donorId: number, data: IVoucherHolderRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IAddVoucherHolderResponse> => {
    //     let options = {
    //         url: `${__API__}/center/${centerId}/donor/${donorId}/voucher`,
    //         data
    //     };

    //     return await dispatch(AuthActionCreators.apiPost(options));
    // },

    // updateVoucherHolder: (centerId: number, donorId: number, id: number, data: IVoucherHolderRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
    //     let options = {
    //         url: `${__API__}/center/${centerId}/donor/${donorId}/voucher/${id}`,
    //         data
    //     };

    //     return await dispatch(AuthActionCreators.apiPut(options));
    // },

    // orderBuccalSwabKit: (centerId: number, donorId: number, id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
    //     let options = {
    //         url: `${__API__}/center/${centerId}/donor/${donorId}/voucher/${id}/order-buccal-swab-kit`
    //     };

    //     return await dispatch(AuthActionCreators.apiPost(options));
    // },

    // getVoucherLookupData: (centerId: number, donorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IVoucherLookupDataResponse> => {
    //     let options = {
    //         url: `${__API__}/center/${centerId}/donor/${donorId}/voucher-lookup-data`
    //     };

    //     return await dispatch(AuthActionCreators.apiGet(options));
    // }
}